"use client";

import { faCircle, faTimes, faUserHeadset } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Counter, useServiceContext } from "@tosize/ui";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { useBackToTopContext } from "~/app/[lang]/overlay/BackToTopContext";

interface ServiceButtonProps {
	title: string;
	unreadCount?: number;
	children?: React.ReactNode;
	isOpen: boolean;
}

export function ServiceButtonRenderer({
	title,
	unreadCount,
	children,
	isOpen,
}: ServiceButtonProps) {
	const pathname = usePathname();
	const { show } = useBackToTopContext();
	const { chatActive, onOpenHandler } = useServiceContext();

	const renderButton = useMemo(() => {
		const excludedRoutes = ["cart", "order", "sales/order", "customer", "contacts"];

		return !excludedRoutes.some((route) => pathname?.startsWith(`/${route}`));
	}, [pathname]);

	return (
		<>
			{chatActive && <>{children}</>}

			{((show && renderButton) || chatActive) && (
				<button
					onClick={() => onOpenHandler()}
					type="button"
					className="flex items-center justify-center rounded-full bg-secondary p-4 text-white leading-none shadow hover:bg-secondary-medium focus-visible:bg-secondary-medium active:bg-secondary-medium motion-safe:transition sm:px-6"
					title={title}
				>
					{isOpen && (
						<FontAwesomeIcon size="2xs" icon={faCircle} fixedWidth className="text-success" />
					)}

					<span className="flex aspect-square items-center justify-center sm:text-lg">
						<FontAwesomeIcon icon={!chatActive ? faUserHeadset : faTimes} fixedWidth />
					</span>

					<span className="ml-2 hidden sm:inline">{title}</span>

					{!!unreadCount && (
						<Counter
							amount={unreadCount}
							className="!bg-primary-medium absolute right-0 bottom-0"
						/>
					)}
				</button>
			)}
		</>
	);
}
